import { AppProvider } from './context/AppContext'
import MenuManagement from './pages/MenuManagement'
import OrdersDashboard from './pages/OrdersDashboard'

function App() {
  return (
    <AppProvider>
      <MenuManagement />
      <hr />
      <OrdersDashboard />
    </AppProvider>
  )
}

export default App
